import { render, staticRenderFns } from "./best-player.vue?vue&type=template&id=66a10fed&scoped=true&"
import script from "./best-player.vue?vue&type=script&lang=js&"
export * from "./best-player.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a10fed",
  null
  
)

export default component.exports